// extracted by mini-css-extract-plugin
module.exports = {"captchaImgDiv":"captcha_captchaImgDiv__3gJja","captchaMainDiv":"captcha_captchaMainDiv__SWGoL","captchaText":"captcha_captchaText__20yJP"};